module.exports = __webpack_public_path__ + "01a1a1fd66dada84e9b3dc58639ecd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/I@2x.png
// module id = 834
// module chunks = 0